const compareCaptcha = captchaCode => (value) => {
    //const captcha = yearsBetweenDates(value, referenceDate);
    console.log('captcahCode='+captchaCode);
    console.log('value='+value);
    return value=== captchaCode;
  };
  
  export default compareCaptcha;